import React from "react";

const Select = props => {
  const { options, label, type, placeholder, onChange,
      value, custom, disabled, name, register, error, children } = props;

  const isError = error ? "input-wrapper-error" : "";

  return (
    <div className={`input-wrapper ${custom} ${isError}`}>
      <label className="input-label">{label}</label>
      <select className="input input-select" type={type} placeholder={placeholder} onChange={onChange} value={value}
       disabled={disabled} {...register(name)}>
        <Option value="">Selecione</Option>
          {children}
      </select>
      {error && <div className="mt-5 text-error">{error.message}</div>}
    </div>
  );
}

export const Option = props => {

  return (
    <option value={props.value}>{props.children}</option>
  );
}

export default Select;